export const COMPANY_DISPLAY_NAME = "COMPANY NAME TBD";
